var _mask, _g, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJiraIntegrationActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 16,
    viewBox: "0 0 13 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 3,
    width: 13,
    height: 13
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 3.51611H12.271V15.9715H0V3.51611Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.77092 15.9708C8.39949 15.9709 8.02803 15.9726 7.6566 15.9702C7.48655 15.9691 7.42018 15.909 7.43728 15.7598C7.50268 15.1893 7.33478 14.6716 7.07315 14.1777C6.58957 13.2647 5.95653 12.4564 5.25119 11.7063C4.46519 10.8703 3.64816 10.0632 2.85857 9.23048C1.88157 8.20018 1.04489 7.07037 0.471458 5.7656C0.243723 5.24749 0.064448 4.7125 0.00649402 4.14606C-0.00696683 4.01458 0.00192022 3.87827 0.0201285 3.74685C0.0437502 3.57622 0.174682 3.48648 0.343855 3.52493C0.440049 3.54682 0.539601 3.58539 0.61944 3.64182C1.23033 4.07354 1.92092 4.27472 2.65704 4.34035C2.84346 4.35695 2.95123 4.42714 3.0135 4.61017C3.32686 5.53093 3.86093 6.32521 4.49967 7.04903C4.97572 7.58848 5.48242 8.10139 5.97911 8.62271C6.13181 8.783 6.1957 8.77863 6.34965 8.62736C7.10424 7.88593 7.8502 7.13456 8.42378 6.24137C8.68141 5.84018 8.90675 5.41427 9.10423 4.98048C9.29236 4.56718 9.56798 4.34388 10.033 4.3062C10.6015 4.2601 11.1082 4.02293 11.5762 3.70486C11.6319 3.66707 11.6867 3.62786 11.7434 3.59165C11.8647 3.51413 11.9904 3.48648 12.1242 3.56287C12.2634 3.64231 12.2757 3.77523 12.2699 3.9121C12.2413 4.59529 12.0498 5.23773 11.772 5.85857C11.1863 7.16762 10.3513 8.30817 9.36873 9.34746C9.05218 9.6823 8.72316 10.0057 8.39578 10.3303C8.15575 10.5684 8.14674 10.6038 8.34947 10.8682C9.16459 11.9314 9.7205 13.1131 9.98057 14.4244C10.0621 14.8357 10.1018 15.256 10.1466 15.6737C10.1713 15.9049 10.1044 15.9676 9.87077 15.9698C9.50418 15.9731 9.13755 15.9706 8.77092 15.9708Z",
    fill: "#2940E5"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.15323 15.9964C2.80163 15.9964 2.45004 15.9977 2.09844 15.9959C1.82915 15.9946 1.77146 15.938 1.78424 15.6766C1.85497 14.2326 2.26834 12.8913 3.02353 11.6534C3.09559 11.5352 3.16754 11.417 3.24224 11.3004C3.33846 11.1504 3.41975 11.1375 3.53695 11.2666C4.08034 11.8652 4.62295 12.4645 5.16017 13.0685C5.3314 13.261 5.32212 13.3335 5.19337 13.5528C5.0414 13.8116 4.88972 14.0716 4.75713 14.3404C4.57827 14.7029 4.48885 15.0925 4.46002 15.4944C4.45467 15.5691 4.4717 15.6454 4.47997 15.7209C4.50207 15.922 4.44284 15.9954 4.23682 15.9978C3.87565 16.002 3.51443 15.999 3.15323 15.999V15.9964Z",
    fill: "#2940E5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.21811 4.82204C5.90508 4.82204 6.59202 4.82164 7.279 4.8222C7.62289 4.82247 7.73838 4.97121 7.6345 5.28602C7.52611 5.61435 7.30366 5.87836 7.07167 6.13063C6.81783 6.40669 6.54512 6.66718 6.27664 6.93079C6.16528 7.04015 6.07237 7.04155 5.9599 6.93348C5.4819 6.47412 5.03421 5.98958 4.69777 5.42487C4.62852 5.30862 4.61365 5.15537 4.60342 5.01722C4.59396 4.8895 4.69071 4.82623 4.82259 4.82362C4.95438 4.82096 5.08626 4.82303 5.21811 4.82303V4.82204Z",
    fill: "#2940E5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.72764 3.06849C2.05207 3.06995 1.53527 2.60293 1.53418 1.99007C1.53306 1.37032 2.06468 0.876899 2.7337 0.876709C3.39085 0.876519 3.94149 1.37457 3.94512 1.97245C3.94884 2.58158 3.4096 3.06702 2.72764 3.06849Z",
    fill: "#2940E5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.14259 6.22141e-06C6.74229 0.0020689 7.23423 0.495104 7.23292 1.09277C7.2316 1.69175 6.73589 2.19248 6.1449 2.19178C5.5548 2.19111 5.03761 1.673 5.04116 1.0861C5.04473 0.49588 5.54969 -0.00202967 6.14259 6.22141e-06Z",
    fill: "#2940E5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.50733 3.06849C8.82411 3.06689 8.32734 2.60556 8.32874 1.97395C8.33011 1.36667 8.86292 0.876763 9.52217 0.876709C10.19 0.876601 10.7411 1.37905 10.7397 1.9866C10.7381 2.60746 10.2111 3.07011 9.50733 3.06849Z",
    fill: "#2940E5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJiraIntegrationActive);
export default __webpack_public_path__ + "static/media/jira-integration-active.d6ee257d2efdbbfb67802fe6430efb27.svg";
export { ForwardRef as ReactComponent };